import { Component, Inject, OnInit } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { IS_MULTI_TENANT } from '../../tokens';
import { NgIf, AsyncPipe } from '@angular/common';
import { CustomerSelectComponent } from '../customer-select/customer-select.component';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'pcp-switch-customer',
    templateUrl: './switch-customer.component.html',
    styleUrls: ['./switch-customer.component.scss'],
    imports: [NgIf, CustomerSelectComponent, FlexModule, AsyncPipe]
})
export class SwitchCustomerComponent implements OnInit {
  constructor(
    public permissions: PermissionsService,
    @Inject(IS_MULTI_TENANT) public isMultiTenant: boolean
  ) {}

  ngOnInit(): void {}
}
